import { hasCardData } from './../../../devices/payment/get-card-details';
import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { ThirdPartyData } from '../../../common/interfaces/states/IPinpadState';
import { store } from '../../../common/redux/configure-store';
import { PinPadActions } from '../../../common/redux/reducers/pinpad-reducer';
import { getEPSData } from '../get-eps-data';

export enum TPSActions {
  Start = 'start',
  Update = 'update',
  Finish = 'finish',
  Cancel = 'cancel',
}

export enum TPSStatus {
  Authorized = 'authorized',
  PreTender = 'preTender',
}

export enum TPSAuthorizationType {
  AuthorizationType = 'Online',
}

export const performTPSAction = async (
  amountDue: number,
  pretenderAmountDue: number,
  action: TPSActions,
  thirdPartyData?: ThirdPartyData,
  status?: TPSStatus,
  tenderId?: string,
): Promise<void> => {
  let data = thirdPartyData ?? buildTPSData(amountDue, pretenderAmountDue, status, tenderId);

  if (!data.transactionId) {
    const transactionId = store.getState().transaction.transactionId ?? '';
    data = { ...data, transactionId }; 
  }

  const axiosConfig: AxiosRequestConfig = {
    url: `/third-party-session/${action}`,
    method: 'POST',
    data,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'Tender - Card - Perform TPS Action' },
  };

  const response = await emeraldRequest<ThirdPartyData>(emeraldRequestParams);
  store.dispatch(PinPadActions.setThirdPartyData(response));
};

const buildTPSData = (
  amountDue: number,
  pretenderAmountDue: number,
  status?: TPSStatus,
  tenderId?: string,
): ThirdPartyData => {
  const { transactionId } = store.getState().transaction;
  const { thirdPartyData } = store.getState().pinPad;
  const callGetCardDetailsByTenderType = store.getState().touchPoint.touchPointConfiguration
    .callGetCardDetailsByTenderType;

  if (!callGetCardDetailsByTenderType && !hasCardData()) {
    throw new Error(`couldn't get the data from the pinpad`);
  }

  const epsData = getEPSData(tenderId);

  const { cardCode: cardId, entryMethod, firstSix, lastFour, cardLength, cardType } = epsData.card;

  let amount = amountDue;
  if (epsData.amountApproved) {
    amount = +epsData.amountApproved;
  }

  let tpsData: ThirdPartyData = {
    action: 'EFTSwipePay', //This is hardcoded as of now. has to be changed later
    transactionId,
    lineId: store.getState().tenderMenu.unPaidPreTender?.lineId?.toString() ?? '1',
    currency: store.getState().itemList.currencyCode,
    status: status,
    authorizationType: TPSAuthorizationType.AuthorizationType,
    payload: {
      amount,
      preTenderAmount: pretenderAmountDue,
      sessionId: epsData.sessionTranID,
      referenceId: epsData.referenceID,
      paymentTranId: epsData.paymentTranID,
      cardDetails: {
        cardId: cardId || '',
        entryMethod: entryMethod || '',
        accountNumber: `${firstSix}${'*'.repeat((cardLength ?? 10) - 10)}${lastFour}`,
        cardType: cardType || '',
      },
      tenderId: tenderId || cardId,
      authCode: epsData.authCode,
    },
  };
  if (thirdPartyData) {
    tpsData = { ...thirdPartyData, ...tpsData };
  }
  return tpsData;
};
